module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("02 "), _c('img', {
    attrs: {
      "alt": "Book Title of Rewind",
      "src": "images/chap.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("I WENT ON MY FIRST MISSION WITH CARSON ROSS SIX")]), _vm._v(" months ago. I’d been certified to work missions as a fully qualified spinner since I was thirteen, and had been through three different agents already, enough to learn that since rewinds make most people uncomfortable, the cops assigned as agents aren’t always the city’s finest. My first agent, Amanda Spruce, worked vice, so we unwound a lot of prostitution cases. In between, she’d tell me stories about her teenage daughters—their clothes, soccer clubs, boyfriends, and parties. She’d laugh about the time her eldest got caught skinny-dipping with her boyfriend in a city reservoir, or when the youngest was found with a joint. Later, we’d round up another drug-addicted hooker and rewind her day before arresting her pimp and any of the johns we managed to ID. Ms. Spruce called the girls whores when she questioned them and once shoved one so hard against the side of the police car she broke the girl’s tooth.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Tito Marquez was a beat cop in a neighborhood known for gang violence. He drank gallons of coffee and spent a lot of time ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("intimidating witnesses before we got around to the rewinds. I’d sit in his car wishing I could speed time up instead of slow it down. The only upside was that we did work some interesting cases. It was with him that I first tasted the grim pleasure of uncovering a murderer.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The last guy was the worst. Jonas Saul was about fifty, with graying hair and a gut he had to wedge under the steering wheel in order to drive. He called me honey and tried to put his arm around me during rewinds. "), _c('em', [_vm._v("Frozen time doesn’t count,")]), _vm._v(" he’d tell me, then laugh his disgusting smoker’s hack as if this phrase might be considered original. Or funny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That first mission with Ross involved a dead baby. The probable verdict was that the death was natural. SIDS, they called it—Sudden Infant Death Syndrome—but the cops thought something might be off, so they brought in Ross to check it out. I was not supposed to be there. Calvin had been Ross’s first spinner, but he’d gotten sick a couple months before, and Ross had been reassigned to the oldest—and theoretically most experienced—spinner at the Center, nineteen-year-old Jack. In his typically loud fashion, Jack had been annoying everyone all week, crowing about how he’d won the agent lottery. That morning, though, Jack got caught making out with another spinner in the second-floor bathroom—a cardinal, if frequent, Center transgression. They were both given extra chores, and I got pulled for Jack’s mission.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Ross and I drove out through an unseasonably hot spring afternoon that even the air conditioning in his car couldn’t tame. Ross asked me lots of questions, which at the time I found disconcerting: What did I like about the Center? What jobs did I do there? Did I think Dr. Barnard, the Center’s director, treated us fairly? None of my other agents wanted to know anything about me except my name. I answered him in monosyllables while surreptitiously studying his ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("profile. I pegged him at late thirties, still fit, with gray peppering his dark blond hair. He gestured with his hands a lot and had laugh lines around his eyes that crinkled when he squinted into the sun.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As we moved east and the city’s hustle shrank down to streets of tired houses, Ross’s conversation slowed. By the time we reached our goal, Ross was frowning with a focused concentration I admired. The house we stopped at had a falling-down fence around a lawn whose only green spots were dandelions. When we got out of the car, the heat descended like a flaming hand pressing the back of my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross rang the doorbell. Twice. No one answered. He had just raised his hand to knock, when the door cracked open to the width allowed by a chain lock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the shaft of darkness, the woman looked insubstantial, as if she’d already been rewound. She wore a thin bathrobe without a belt and her feet were bare. Misery wafted from her, mingling with the stench of spoiled milk and unwashed skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mrs. Montgomery?” Ross asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The woman’s face remained so blank she might have been the one who died.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m Agent Carson Ross.” He showed her his badge. “And this is spinner Alexandra Manning. We’re here to look into the death of Rosalind Montgomery. We have a time search warrant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The woman stared vaguely at the paper in Ross’s hand. No spark showed even the faintest hint of comprehension. Ross stuffed the papers back into his pocket. When he spoke again his voice was gentle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“May we come in?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The door closed. I thought Mrs. Montgomery had dismissed us, but a moment later I heard the slide of the lock, and the door swung open. I had to force myself to follow Ross inside. Mrs. Montgomery ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("was already shuffling over to a forlorn sofa. She must have been there a while. An open pizza box displayed congealed pieces of barely eaten pie while a television flashed images through a muted screen. Somewhere nearby, a diaper pail needed emptying.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross cleared his throat. “Can you show me where Rosalind died?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mrs. Montgomery pointed vaguely toward a closed door. Ross thanked her. I tripped over a stroller in my eagerness to get away from the unresponsive woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The bedroom was worse. For one thing, it turned out to be the home of the overflowing diaper pail. The cloud of ammonia that hit us when we entered the room made me gag. Ross put a hand up to his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Give me your arm,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Freeze time, quick, so we can lessen the smell.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("I held out my arm and he unlocked my leash. As soon as the metal left my skin I touched two fingers to Ross’s bare wrist and stopped time. Ross grabbed the door, waving the wood back and forth to make enough breeze to disperse the stench-laden molecules. It didn’t erase the smell, but at least my eyes quit watering. I blinked, taking in a blanket-strewn mattress on the floor, a sagging dresser, and window blinds that didn’t close all the way. Only the far corner showed signs of care. Here, the wall was painted a soft yellow. On the floor, a makeshift changing station made of a stack of towels rested next to a pile of neatly folded baby clothes. Above that, someone had taped up three photographs. The first showed a dozing infant in a stretchy pink-and-blue hat. The second was a studio portrait of a startled-looking child with a flowered band around her bald head. The last was a snapshot of a laughing woman holding the baby tight against her chest. The girl’s fat cheeks were split by a gummy smile, one little ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("hand wrapped around a strand of her mother’s hair. The mother was a barely recognizable version of Mrs. Montgomery.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Let’s get this over with,” Ross said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I nodded, grabbing time so hard the rewind spun backward with a force that made me sway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How far back do I need to go?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A neighbor called it in this morning. I gather the child died sometime the day before. We’ll have to go back at least twenty-four hours—will that be a problem for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, sir,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The phantom police backed in first, quickly followed by a guy from the morgue, who replaced a tiny body into a coil of blankets in the center of the bed. Rosalind’s rosebud mouth hung open, relaxed far beyond the temporary release of sleep. I kept the rewind moving at a fast clip. Police wandered in and out, poking in drawers and un-taking pictures. Their rewound voices kept up an incomprehensible hum, punctuated by ugly squawks from their radios. Mrs. Montgomery never appeared. Presumably she’d already taken up residence on her sofa. Light leached away from the afternoon until last night’s darkness settled an overlay of gloom, though the fetid air around us kept its real-time heat. Sweat tickled the edges of my hairline. Rosalind lay alone in her blankets, unmoving and definitely dead. I spun the rewind harder. Light returned. I pulled faster still, racing a growing tiredness as we moved farther back. The sun brightened, receded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the rosy light of dawn, Mrs. Montgomery staggered backward into the room. She moved like a barely animate china doll, as if any fast movement might shatter her. My grip on time slipped. The image stuttered to a halt.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“Is this as far as you can rewind?” Ross asked. “I understand. This is much farther than I expected.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No.” I pressed my lips together, barely giving my words enough room to slip out. “I can go further. It’s just …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mrs. Montgomery’s body strained with a barely suppressed scream. The idea of seeing her turn around and face the dead baby terrified me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross put an arm around my shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Hey, it’s OK.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I stiffened beneath his touch. He let me go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You don’t have to watch,” Ross said. “Close your eyes. I’ll tell you what to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I escaped into the darkness of my closed lids and concentrated on the strands flowing through me. I eased them out, fast or slow, depending on what Ross asked. Only when I heard his soft "), _c('em', [_vm._v("oh")]), _vm._v(" of comprehension did I peek. The shadowy form of Mrs. Montgomery slept, her body rising and falling in rhythmic exhaustion. A thin bedspread covered most of her body. It must have been a cool night because her exposed arm was dotted with goosebumps. Next to her, baby Rosalind lay packed into a carefully constructed nest of pillows and blankets. Mrs. Montgomery’s outstretched arm curved around the soft pile, the unconscious gesture of a mother protecting her young. Except the arm was not protecting. Its weight had pushed the heap of blankets forward, so that the edges of the nest caved over, pressing down onto the form beneath and covering Rosalind’s head with smothering comfort. As I watched, one chubby hand waved, the tiny fingers unable to coordinate an assault on the warm excess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I slammed my eyes shut again, wishing I hadn’t ignored Ross’s directions. Time scraped through my mind like fingernails.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Ross let out a long sigh. “You can let it go now.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I released my hold, suffering the swirling dizziness before opening my eyes. The horrible urine smell exploded in my nostrils. A time headache pounded inside my skull.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Come on,” Ross said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mrs. Montgomery still perched on her sofa, staring at the soundless TV. The flashing images cast strange lights on her skin, now red, now green. I imagined Ross telling her the baby’s death was her fault, saw the words falling on her like hammers. I wondered if it were possible for someone to dissolve. Mrs. Montgomery already seemed so frail. This news would surely crush her into multicolored dust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We’re done, ma’am,” Ross said. I held my breath. Despite the heat, my body shivered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The initial assessment was right,” he said. “Your baby died of SIDS. It was nobody’s fault. I’m so sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("An earthquake could have rocked the building and not stunned me as much as Ross’s words. Not because I’d never heard a cop shade the truth before, but because I’d never seen one do it to protect someone like this: a poor, unimportant woman with nothing to offer in return.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mrs. Montgomery raised her head. Her mouth worked, as if she barely remembered how to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you sure?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m positive.” Ross gestured toward me. “We both saw the rewind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her eyes went wide. Whole worlds could be lost in the blackness of those pupils. I wondered what she knew. Or suspected. What she was willing to forget.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Thank you,” she said.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Ross ushered me out to the car and drove to a fast food restaurant. He ordered three hamburgers, fries, and two chocolate milkshakes. I ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("hoped he’d eat quickly. I wanted to put as much distance between me and that rewind as possible. We parked under a tree. Ross adjusted a vent on the dash so cold air blasted over me.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m always famished after a rewind,” he said, handing me a burger. “Aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The unexpected reward filled my hand. I’d never heard of an agent buying a spinner lunch before. Ross slid his seat backward and settled in to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Won’t the Center wonder where we are?” I asked, worried Ross’s generosity would get us into trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross shrugged. “They don’t know how long the mission lasted.” He noticed my untasted food. “Unless you want to go back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, sir.” I unwrapped the burger and took a bite. Ketchup squirted onto my tongue, the tangy flavor a perfect counterpoint to the chewy meat. I realized I was starving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You were good back there,” Ross said. “Your rewind was really clear, even after almost thirty-six hours. How long can you go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I rewound two and a half days once,” I said, my words muffled by the food stuffed in my cheek. Ross whistled appreciatively. Spurred by the praise, I added, “And I’ve held time for over two hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Impressive,” Ross said. “I might have to keep you around. Think you can handle homicide?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I swallowed the entire lump of burger in one painful gulp. He wanted me as his permanent spinner? I wiped the ketchup from my lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ve seen worse, sir,” I said, though I wasn’t sure it was true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t call me sir,” Ross said. “If we’re going to be partners, there’s no need to be so formal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Partners. The word sounded like a promise. The idea that this decent man wanted to work with me was the best present I’d ever gotten. Happiness made me brave.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“Why did you do it?” I asked. “Why did you lie to Mrs. Montgomery?”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross handed me one of the milkshakes and unwrapped his second burger. “Let me ask you a question. Why do you do rewinds?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Because I have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Fair enough. Does the job ever make you feel good?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Sometimes.” I considered the question. “I rewound a case for Agent Marquez once that proved the guy the police had arrested was innocent. The real culprit had framed him. That felt pretty good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It felt good because the truth led to justice. Truth isn’t always that straightforward, though. In Mrs. Montgomery’s case, the truth would have destroyed an already devastated woman, and for what? The truth wouldn’t bring back baby Rosalind. The truth would only have made things worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I swirled some chocolate shake around in my mouth. It tasted sweet and deliciously cool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What will you write in your report?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That the baby died of SIDS.” Ross turned toward me. “What do you think about letting what happened in that rewind be our secret, known to nobody in the world but us two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I smiled at him so widely I probably looked like a demented jack-o-lantern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’d like that,” I said, and took another bite of burger to staunch the ridiculous grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thoughts sprouted in my brain like shoots after a spring shower, fragile and teeming with possibility. For as long as I could remember, people had told me that my abilities made me different. Ross was the first person to say they made me special.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3f853a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Chapter02.vue
// module id = 69
// module chunks = 0